import React, { memo } from 'react';
import JiraPlaceholder from '@atlassian/jira-placeholder/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyAtlassianOnboardingNav4 = lazyForPaint(
	() =>
		import(/* webpackChunkName: "async-jira-atlassian-onboarding-nav4" */ './index').then(
			({ Nav4Onboarding }) => Nav4Onboarding,
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const AsyncAtlassianOnboardingNav4 = memo(() => {
	return (
		<JSErrorBoundary
			id="asyncAtlassianOnboardingNav4"
			packageName="jiraAtlassianOnboardingNav4"
			teamName="jira-cosmos"
			fallback="unmount"
		>
			<JiraPlaceholder name="lazyAtlassianOnboardingNav4">
				<LazyAtlassianOnboardingNav4 />
			</JiraPlaceholder>
		</JSErrorBoundary>
	);
});

AsyncAtlassianOnboardingNav4.displayName = 'AsyncAtlassianOnboardingNav4';

export default AsyncAtlassianOnboardingNav4;
